import elementUi from 'element-ui/lib/locale/lang/en.js';

// Overwrites
elementUi.el.pagination.pagesize = ' / page';

export default elementUi;
